import { render } from "./RecipientDeathSectionDetails.vue?vue&type=template&id=dd341ef0&scoped=true"
import script from "./RecipientDeathSectionDetails.vue?vue&type=script&lang=js"
export * from "./RecipientDeathSectionDetails.vue?vue&type=script&lang=js"

import "./RecipientDeathSectionDetails.vue?vue&type=style&index=0&id=dd341ef0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd341ef0"],['__file',"src/components/RecipientDeathSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd341ef0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd341ef0', __exports__)) {
    api.reload('dd341ef0', __exports__)
  }
  
  module.hot.accept("./RecipientDeathSectionDetails.vue?vue&type=template&id=dd341ef0&scoped=true", () => {
    api.rerender('dd341ef0', render)
  })

}


export default __exports__